import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { LearnerEditDto } from "src/app/_models/LearnerEditDto";
import { LearnerList } from "src/app/_models/LearnerList";
import { Userprofile } from "src/app/_models/Userprofile";
import { EditLearnerActionTypes } from "src/app/constants/StoreConstants";

export const SetEditLearner = createAction(
  EditLearnerActionTypes.SetEditLearner,
  props<{data: LearnerList}>()
);

export const SetEditLearnerSuccess = createAction(
  EditLearnerActionTypes.SetEditLearnerSuccess
);

export const LoadLearnerData = createAction(
  EditLearnerActionTypes.LoadLearnerData,
  props<{data: Userprofile}>()
);

export const LoadLearnerDataSuccess = createAction(
  EditLearnerActionTypes.LoadLearnerDataSuccess,
  props<{data: Userprofile}>()
);

export const EditLearner = createAction(
  EditLearnerActionTypes.EditLearner,
  props<{payload: LearnerEditDto}>()
);

export const EditLearnerSuccess = createAction(
  EditLearnerActionTypes.EditLearnerSuccess,
  props<{result: LearnerList}>()
);

export const EditLearnerError = createAction(
  EditLearnerActionTypes.EditLearnerError,
  props<{error: HttpErrorResponse}>()
);